import * as React from "react";
import { forwardRef } from "react";
const SvgRefreshBlue = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: 18, height: 18, viewBox: "0 0 24 24", fill: "none", stroke: "#3559ff", strokeWidth: 2.2, strokeLinecap: "round", strokeLinejoin: "round", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("polyline", { points: "23 4 23 10 17 10" }), /* @__PURE__ */ React.createElement("polyline", { points: "1 20 1 14 7 14" }), /* @__PURE__ */ React.createElement("path", { d: "M3.51 9a9 9 0 0114.13-3.36L23 10" }), /* @__PURE__ */ React.createElement("path", { d: "M20.49 15a9 9 0 01-14.13 3.36L1 14" }));
const ForwardRef = forwardRef(SvgRefreshBlue);
export default ForwardRef;
